import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NationalParksRoutingModule } from './national-parks-routing.module';
import {NationalParksComponent} from './components/national-parks/national-parks.component';
import {TarangireComponent} from './components/tarangire/tarangire.component';
import {LakeManyaraComponent} from './components/lake-manyara/lake-manyara.component';
import {SerengetiComponent} from './components/serengeti/serengeti.component';
import {OlduvaiGorgeComponent} from './components/olduvai-gorge/olduvai-gorge.component';
import {ArushaComponent} from './components/arusha/arusha.component';
import {IraqwCultureCenterComponent} from './components/iraqw-culture-center/iraqw-culture-center.component';
import {NgorongoroComponent} from './components/ngorongoro/ngorongoro.component';
import {AgmCoreModule} from '@agm/core';
import {WidgetsModule} from '../widgets-module/widgets.module';
import {DirectivesModule} from '../directives-module/directives.module';

@NgModule({
  declarations: [
      NationalParksComponent,
      TarangireComponent,
      LakeManyaraComponent,
      SerengetiComponent,
      OlduvaiGorgeComponent,
      ArushaComponent,
      IraqwCultureCenterComponent,
      NgorongoroComponent,
  ],
  imports: [
    CommonModule,
    NationalParksRoutingModule,
    AgmCoreModule,
    WidgetsModule,
    DirectivesModule
  ]
})
export class NationalParksModule { }
